module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('a', {
    attrs: {
      "id": "p12"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-weight": "bold",
      "font-family": "arial"
    }
  }, [_c('span', {
    staticClass: "color-FF5100"
  }, [_vm._v("Equipment")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("Landfills across this great land are awash with sleek, colorful, leather-thonged sets of overly designed barbecue tools, none of which have a speck of grill grease on them, as they never made it out of the faux attaché case they came in. These tools may look like they’ve come straight from a lab at MIT, but more often than not, the spatulas are too narrow and the tongs don’t grip. What’s worse, they are so rigid they require the grip strength of an offensive tackle to bring them together. When it comes to grill tools, take function over form. Rest assured, even the great chefs in America grill with only a pair of aluminum tongs and the most basic of spatulas, even if they have a line of utensils with their name on them. One of the reasons dads feel at home around the grill is because of its uncomplicated efficiency. Let’s keep it that way.")])]), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "p12"
    }
  }), _c('a', {
    attrs: {
      "id": "title2"
    }
  }, [_c('h1', {
    staticClass: "title-section1 color-FF5100 font-GoudyHeavyfaceBT-Regular-3_1-11_75"
  }, [_vm._v("The Grill: Charcoal or Gas")]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-13"
  }, [_vm._v("Both charcoal and gas work great for basic grilling. If your intention is to grill a steak medium-rare with a perfectly charred outside and a deep rosy, medium-rare center, either will work just fine. A charcoal grill is capable of producing higher heat, but you’ll rarely need a fire that is quite so intense. Besides, some of the newer gas models are pumping out some serious BTUs. Most serious barbecue aficionados, however, prefer charcoal to gas. It’s more intuitive. If there’s a bigger pile of charcoal on one side of the grill than on the other, it’s obvious which side will be hotter. But if you are the kind of person who balks at the process of lighting the coals, who will be more inclined to get out the grill if you need only turn the knob to “light,” you should definitely get yourself a gas grill.")])]), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title2"
    }
  }), _c('a', {
    attrs: {
      "id": "title3"
    }
  }, [_c('h1', {
    staticClass: "title-section2 color-3C1C00 font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("Charcoal")]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("1. ")]), _c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-13"
  }, [_vm._v("One benefit of these grills is that they impart the smoky flavor of the charcoal. This becomes even more distinct when you use real wood charcoal instead of the pressed briquettes.")])]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-3C1C00 font-AtmaSerif-MediumRoman-5_1-13"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("2. ")]), _c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-13"
  }, [_vm._v("It is much easier to add wood chips for smoking to a charcoal fire. This will allow you to further enhance the flavor when grilling over high heat or to infuse the food with the heady flavor of the wood chips by cooking slowly over indirect heat.")])]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-3C1C00 font-AtmaSerif-MediumRoman-5_1-13"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("3. ")]), _c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-13"
  }, [_vm._v("Charcoal grills allow you to cook with the top off, so you can better see the progress of the grilling.")])])]), _c('a', {
    attrs: {
      "id": "p13"
    }
  }, [_c('div', {
    staticClass: "illustype_image color-3C1C00 font-AtmaSerif-MediumRoman-5_1-13"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "e9780811866989_i0007.jpg",
      "src": "images/e9780811866989_i0007.jpg"
    }
  })])])])]), _c('a', {
    attrs: {
      "id": "p13"
    }
  }), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "p13"
    }
  }), _c('a', {
    attrs: {
      "id": "title4"
    }
  }, [_c('h1', {
    staticClass: "title-section2 color-3C1C00 font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("Gas")]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("1. ")]), _c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-13"
  }, [_vm._v("These grills are easier to use than charcoal ones, as there is no need to light the coals.")])]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-3C1C00 font-AtmaSerif-MediumRoman-5_1-13"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("2. ")]), _c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-13"
  }, [_vm._v("The burners may seem to be putting out even heat, but there will still be hot and cool spots on the grill. Even when new, most grill burners burn just unevenly enough to create hotter and cooler cooking zones.")])]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-3C1C00 font-AtmaSerif-MediumRoman-5_1-13"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("3. ")]), _c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-13"
  }, [_vm._v("Although with some effort you can maneuver a drip pan with soaked wood chips to sit above the burners and under the grate, smoking on a gas grill is less reliable than on a charcoal grill and is not heartily recommended. If you want to smoke foods, you’re best off investing in a smoker to supplement your gas grill.")])]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-3C1C00 font-AtmaSerif-MediumRoman-5_1-13"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("4. ")]), _c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-13"
  }, [_vm._v("Most gas grills need the top to be closed in order to maintain their heat, making it somewhat harder to keep track of the progress of the grilling.")])])])])]), _c('a', {
    attrs: {
      "id": "title4"
    }
  }), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title4"
    }
  }), _c('a', {
    attrs: {
      "id": "title5"
    }
  }, [_c('h1', {
    staticClass: "title-section1 color-FF5100 font-GoudyHeavyfaceBT-Regular-3_1-11_75"
  }, [_vm._v("Other Equipment")]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-GoudyHeavyfaceBT-Regular-3_1-9_55"
  }, [_vm._v("Lots of serving bowls and platters")]), _vm._v(" "), _c('p', {
    staticClass: "running_txt color-3C1C00 font-AtmaSerif-MediumItalic-6_1-11"
  }, [_vm._v("(Having a few too many will only make your grilling life easier—remember, you can’t bring the cooked food into the house on the same platter you brought the raw food out on unless you take the time to clean it or it’s a platter of tofu.)")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_list"
  }, [_c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("Several large serving spoons")])])]), _vm._v(" "), _c('p', {
    staticClass: "ingred_list"
  }, [_c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("Chimney-style charcoal igniter")])])]), _vm._v(" "), _c('p', {
    staticClass: "ingred_list"
  }, [_c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("2 ")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("cutting boards"), _c('br')])]), _c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("1 ")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("chef’s knife, ")])]), _c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("1 ")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("serrated knife"), _c('br')])]), _c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("1 ")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("paring knife"), _c('br')])]), _c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("4 ")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("mixing bowls"), _c('br'), _vm._v(" Long-handled tongs"), _c('br'), _vm._v(" Spatula and fish spatula"), _c('br')])]), _c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("2 ")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("small saucepans for reheating on the grill"), _c('br'), _vm._v(" Cast iron skillet for cooking on the grill"), _c('br'), _vm._v(" Can opener, church key, and corkscrew"), _c('br'), _vm._v(" Lots of paper towels"), _c('br'), _vm._v(" Matches or lighter fluid–filled match thing"), _c('br'), _vm._v(" Prep table, ")])]), _c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("3 ")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("to ")])]), _c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("4 ")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("feet long and situated by the grill")])])])])])]), _c('a', {
    attrs: {
      "id": "title5"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ada053cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/007chapter02.vue
// module id = 75
// module chunks = 0